import { Action } from "@ngrx/store";

export const GET_BUILDING_INVENTORY_LIST = '[Building Inventory] Get Building Inventory List';
export const GET_BUILDING_INVENTORY_LIST_SUCCESS = '[Building Inventory] Get Building Inventory List Success';
export const GET_BUILDING_INVENTORY_LIST_FAIL = '[Building Inventory] Get Building Inventory List Fail';
export const CLEAR_BUILDING_INVENTORY_LIST = '[Building Inventory] Clear Building Inventory List';
export const UPDATE_INSURANCE_APPROACH = '[Building Inventory] Update Insurance Approach';
export const UPDATE_INSURANCE_APPROACH_SUCCESS = '[Building Inventory] Update Insurance Approach success';
export const UPDATE_INSURANCE_APPROACH_FAIL = '[Building Inventory] Update Insurance Approach Fail';
export const RESET_BUILDING_INVENTORY_CRUD = '[Building Inventory] Reset Building Inventory CURD';

export class GetBuildingInventoryList implements Action {
    readonly type = GET_BUILDING_INVENTORY_LIST;
    constructor(public payload: { institutionId: number } = null) { }
}

export class GetBuildingInventoryListSuccess implements Action {
    readonly type = GET_BUILDING_INVENTORY_LIST_SUCCESS;
    constructor(public payload: any = null) { }
}

export class GetBuildingInventoryListFail implements Action {
    readonly type = GET_BUILDING_INVENTORY_LIST_FAIL;
    constructor(public payload: any = null) { }
}

export class ClearBuildingInventoryList implements Action {
    readonly type = CLEAR_BUILDING_INVENTORY_LIST;
    constructor(public payload: any = null) { }
}

export class UpdateInsuranceApproach implements Action {
    readonly type = UPDATE_INSURANCE_APPROACH;
    constructor(public payload: any = null) { }
}

export class UpdateInsuranceApproachSuccess implements Action {
    readonly type = UPDATE_INSURANCE_APPROACH_SUCCESS;
    constructor(public payload: any = null) { }
}

export class UpdateInsuranceApproachFail implements Action {
    readonly type = UPDATE_INSURANCE_APPROACH_FAIL;
    constructor(public payload: any = null) { }
}

export class ResetBuildingInventoryCURD implements Action {
    readonly type = RESET_BUILDING_INVENTORY_CRUD;
    constructor(public payload: any = null) { }
}

export type BuildingInventoryActions =
    | GetBuildingInventoryList
    | GetBuildingInventoryListSuccess
    | GetBuildingInventoryListFail
    | ClearBuildingInventoryList
    | UpdateInsuranceApproach
    | UpdateInsuranceApproachSuccess
    | UpdateInsuranceApproachFail
    | ResetBuildingInventoryCURD;